import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import Routes from './routes';
import GlobalStyle from './styles/global';
import 'antd/dist/result.css';

import { store, persistor } from './store';

function App() {
  useEffect(() => {
    const { protocol, hostname, pathname, hash } = window.location;

    // Check if the current protocol is HTTP, then redirect to HTTPS
    if (protocol === 'http:') {
      window.location.href = `https://${hostname}${pathname}${hash}`;
    }
  }, []);
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Routes />
      </PersistGate>
      <GlobalStyle />
    </Provider>
  );
}

export default App;
